// Note: The API doesn't have a CREATE endpoint, only UPDATE (PUT/PATCH)
// This hook is kept for consistency but will not be used
// Doctor static data should be created through the external system
import { useState } from "react";
import { toast } from "react-toastify";

const useCreateDoctorStatic = ({ getAllDoctorStatic = () => {}, onCloseModal = () => {} }) => {
  const [isDoctorStaticCreating, setIsDoctorStaticCreating] = useState(false);

  const onCreateDoctorStatic = async (payload) => {
    setIsDoctorStaticCreating(true);
    try {
      // API doesn't support creation, only updates
      toast.error("Doctor static data creation is not supported. Please use the external system to create doctor records.");
    } catch (error) {
      console.error(error, "error");
      toast.error("Operation not supported");
    } finally {
      setIsDoctorStaticCreating(false);
      onCloseModal();
    }
  };

  return {
    onCreateDoctorStatic,
    isDoctorStaticCreating,
  };
};

export default useCreateDoctorStatic;

